module.exports = __webpack_public_path__ + "img/half-circle.000f98fc.svg";